import { watchKeyboardBtnPress } from '@cred/shared/events'

export const getKeyDownProps = ({ onKeyDown, ignoreKeyDown, href }) => {
  if (onKeyDown) {
    return { onKeyDown }
  }

  if (ignoreKeyDown || href) {
    return {}
  }

  return { onKeyDown: watchKeyboardBtnPress() }
}
